import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-button',
    template: `
    <div [formGroup]="form">
    <div *ngFor="let option of to.options; let i = index;" class="radio">
      <!-- <label class="custom-control custom-radio">
        <input
          [name]="id"
          [id]="id + '_' + i"
          type="radio"
          [value]="option.key"
          [formControl]="formControl"
          [formlyAttributes]="field" [ngClass]="to.style">
        <span class="custom-control-label">{{ option.value }}</span>
        <span class="custom-control-indicator"></span>
      </label> -->

      <div [ngClass]="to.divStyle">
		<span [ngClass]="to.numberingStyle">{{(i+1)}}</span>
		<!-- <label for="fordLayout1" class="flayout1">				
        </label> -->
        <img [src]="option.file_name" [ngClass]="to.imgStyle">
		<br>
        <span [ngClass]="to.textStyle" *ngIf="option.isChecked">{{to.text}}</span>
        <span [ngClass]="to.textStyle" *ngIf="!option.isChecked">&nbsp;</span>
        <input
          [name]="id"
          [id]="id + '_' + i"
          type="radio"
          [value]="option.key"
          [formControl]="formControl"
          [formlyAttributes]="field" [ngClass]="to.style" [checked]="option.isChecked">
	</div>
    </div>
  </div>
    `,
})
export class FormlyFieldEpRadio extends FieldType {

}